import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api";

export const GetDashboard = createAsyncThunk(
  "ls/GetDashboard",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/users/landlord/dashboard`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  dashboard: {},
};

export const Dashboardlice = createSlice({
  name: "dashboard",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(GetDashboard.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetDashboard.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          dashboard: action.payload,
        };
      })
      .addCase(GetDashboard.rejected, (state, action) => {
        return {
          isLoading: false,
          error: action.payload,
        };
      });
  },
});

export default Dashboardlice.reducer;
